import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { getARecommendGroupSoft } from '../../actions/arecommend';
import ASoftCard from '../../components/ASoftCard/ASoftCard';
import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import { cleanSearchRecommend } from '../../actions/search';
import styles from './AGroup.module.less';

const selectGroupSoft = createSelector(
  state => state.arecommend,
  arecommend => arecommend.groupSoft,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const groupSoftData = useSelector(selectGroupSoft);
  const localSoftsInit = useSelector(selectLocalSoftsInit);
  const logInfoData = useSelector(selectLogInfo);

  const pageSize = 60;
  const showSize = 9;
  const [showGroups, setShowGroups] = useState([]);

  useEffect(() => {
    if (!groupSoftData || groupSoftData.length === 0) {
      dispatch(getARecommendGroupSoft({ skip: 0, limit: pageSize }));
    } else {
      const show_groups = [];
      groupSoftData.forEach(group => {
        const items = [];
        if(group && group.apps && group.apps.length > 0) {
          group.apps.forEach(item => {
            const found = localSoftsInit.find(soft => (
              (item.androidType !== '1' && (soft.softID === item.softID || soft.softID === item.SoftID)) ||
              (item.androidType === '1' && soft.packageName === item.packageName)
            ));
            if (found === undefined) {
              items.push(item);
            }
          });
        }
        show_groups.push({ ...group, showApps: items.slice(0, showSize) });
      });
      setShowGroups(show_groups);
    }
  }, [dispatch, groupSoftData, localSoftsInit]);


  const handleShowMore = useCallback(() => {
    // 推荐页面banner点击打桩
    dispatch(
      logging({
        category: 'C',
        action: 'A_Reco_Groupmore',
        label: '',
        param2: {
          source: 'A_Reco_Groupmore',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: 'A_Reco_Groupmore',
        source_pp: logInfoData.source_p,
      }),
    );
    dispatch(cleanSearchRecommend());
  }, [dispatch]);

  return (
    showGroups &&
    showGroups.length > 0 && (
      <React.Fragment>
        {showGroups.map((group, i) => (
          group && group.showApps && group.showApps.length > 0 && (
            <div className={styles.softGroup} key={i}>
              <div className={styles.softGroup_header}>
                <div className={styles.softGroup_header_title}>{group.desc}</div>
                <Link
                  className={styles.softGroup_header_link}
                  onClick={() => {
                    handleShowMore();
                  }}
                  to={{ pathname: `${CONTEXT}/androidmore` }}
                />
              </div>
              <div className={styles.soft_cards}>
                {group.showApps.map((soft, j) => (<ASoftCard soft={soft} logInfo={{ source: `A_Reco_Group||${group.code}` }} key={j} />))}
              </div>
            </div>
          )
        ))}
      </React.Fragment>
    )
  );
});
